var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17C11.25 13.8244 13.8244 11.25 17 11.25C18.5876 11.25 20.0261 11.8944 21.0659 12.9341C22.1056 13.9739 22.75 15.4124 22.75 17C22.75 20.1756 20.1756 22.75 17 22.75C15.4124 22.75 13.9739 22.1056 12.9341 21.0659C11.8944 20.0261 11.25 18.5876 11.25 17ZM17 12.75C14.6528 12.75 12.75 14.6528 12.75 17C12.75 17.903 13.0311 18.7396 13.5113 19.428L19.428 13.5113C18.7396 13.0311 17.903 12.75 17 12.75ZM20.4887 14.572L14.572 20.4887C15.2604 20.9689 16.097 21.25 17 21.25C19.3472 21.25 21.25 19.3472 21.25 17C21.25 16.097 20.9689 15.2604 20.4887 14.572Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6018 21.8396C10.4524 20.5579 9.75 18.8592 9.75 17C9.75 15.0616 10.5108 13.3008 11.75 12H4C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C10.5486 22 11.0842 21.9448 11.6018 21.8396Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlock);
export default __webpack_public_path__ + "static/media/user-block.f2fc798e336c01204e6fa26d6de608d2.svg";
export { ForwardRef as ReactComponent };